import lb from '@/lib/loopback';

export function countPC() {
  return lb
    .get('/Palavraschaves/count')
    .then(res => res.count);
}

export function findPC(keyword = null) {
  return lb
    .get(`/Palavraschaves/filter?keyword=${keyword}`)
    .then(data => data);
}

export function deletePC(id) {
  return lb.delete(`/Palavraschaves/${id}`);
}

export function updatePC(company) {
  return lb.patch(`/Palavraschaves/${company.id}`, company)
    .then(data => data);
}

export function createDocumentPC(company) {
  return lb.patch('/Palavraschaves/', company)
    .then(data => data);
}

export default {
  deletePC,
  findPC,
};
